"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var permission_container_1 = require("./permission-container");
var RolesContainer = /** @class */ (function () {
    function RolesContainer() {
        this.roles = [];
        this.roleDict = {};
        if (RolesContainer.instance) {
            return RolesContainer.instance;
        }
        RolesContainer.instance = this;
    }
    RolesContainer.prototype.addRole = function (role) {
        if (!this.validateRole(role)) {
            throw Error("Role is invalid");
        }
        this.roles.push(role);
        this.roleDict[role.name] = role;
    };
    RolesContainer.prototype.setRoles = function (roles) {
        this.roles = [];
        this.roleDict = {};
        var permissionsRepo = new permission_container_1.PermissionContainer();
        for (var _i = 0, roles_1 = roles; _i < roles_1.length; _i++) {
            var role = roles_1[_i];
            this.addRole({
                name: role.name,
                permissions: role.permissions.map(function (p) { return permissionsRepo.getPermission(p); })
            });
        }
    };
    RolesContainer.prototype.validateRole = function (role) {
        var permissions = new permission_container_1.PermissionContainer();
        return role.permissions.every(function (permission) {
            return !!permission && permissions.permissionExists(permission.name);
        });
    };
    RolesContainer.prototype.getRole = function (name) {
        return this.roleDict[name];
    };
    return RolesContainer;
}());
exports.RolesContainer = RolesContainer;
//# sourceMappingURL=roles-container.js.map